module.exports = __webpack_public_path__ + "assets/453f58202883e8391ff3b8285f9efc54.svg";